// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gB","advertCardNum":"c-a_gC"};